import { Table } from "./Table";
import { Form } from "./Form";
export const User = {
  Table,
  Form,
};
